import React from "react";

const Contact = () => {
  return (
    <section id="Contact" className="contact">
      <div className="contact__inner">
        <h2 className="title">Get in Touch</h2>
        <p className="description">
          I'm currently available for work in freelance and mentoring if you
          want to learn programming, My inbox is always open. Whether you have a
          question or just wanna say hi, I'll try my best to get back to you !
        </p>
        <a
          href="mailto:salman.prottoy@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="contact__button">Say Hello</button>
        </a>
      </div>
    </section>
  );
};

export default Contact;
